import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLike = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 21.6516C12.31 21.6516 12.61 21.6116 12.86 21.5216C16.68 20.2116 22.75 15.5616 22.75 8.69156C22.75 5.19156 19.92 2.35156 16.44 2.35156C14.75 2.35156 13.17 3.01156 12 4.19156C10.83 3.01156 9.25 2.35156 7.56 2.35156C4.08 2.35156 1.25 5.20156 1.25 8.69156C1.25 15.5716 7.32 20.2116 11.14 21.5216C11.39 21.6116 11.69 21.6516 12 21.6516ZM16.44 3.85156C19.09 3.85156 21.25 6.02156 21.25 8.69156C21.25 15.5216 14.68 19.3216 12.37 20.1116C12.19 20.1716 11.8 20.1716 11.62 20.1116C9.32 19.3216 2.74 15.5316 2.74 8.69156C2.74 6.02156 4.9 3.85156 7.55 3.85156C9.07 3.85156 10.48 4.56156 11.39 5.79156C11.67 6.17156 12.31 6.17156 12.59 5.79156C13.52 4.55156 14.92 3.85156 16.44 3.85156Z",
		fill: "#646464"
	})
});
export default SvgLike;
